/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq2a1Inputs */

const zh_pricing_faq2a1 = /** @type {(inputs: Pricing_Faq2a1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以！你可以随时升级到更高级的方案，也可以在当前计费周期结束后降级。`)
};

const en_pricing_faq2a1 = /** @type {(inputs: Pricing_Faq2a1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absolutely! You can upgrade to a higher plan at any time, or downgrade after your current billing cycle ends.`)
};

const es_pricing_faq2a1 = /** @type {(inputs: Pricing_Faq2a1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Por supuesto! Puedes actualizar a un plan superior en cualquier momento o degradar después de que termine tu ciclo de facturación actual.`)
};

/**
* | output |
* | --- |
* | "Absolutely! You can upgrade to a higher plan at any time, or downgrade after your current billing cycle ends." |
*
* @param {Pricing_Faq2a1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faq2a1 = /** @type {((inputs?: Pricing_Faq2a1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq2a1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faq2a1(inputs)
	if (locale === "en") return en_pricing_faq2a1(inputs)
	return es_pricing_faq2a1(inputs)
});
export { pricing_faq2a1 as "pricing_faq2A" }